module.exports = __webpack_public_path__ + "img/25.14cce7f9.jpg";